import React, { Component } from 'react';
import Modal from '../../helpers/Modal';
import SelectField from '../../forms/SelectField';
import { filter, get } from 'lodash';
import { toSelectionFormat } from '../../../lib/collection.utils';
import TextArea from '../../forms/TextArea';
import ModalButtons from '../forms/ModalButtons';
import DatepickerUnlimited from '../../forms/DatepickerUnlimited';
import { UNLIMITED_DATE } from '../../../constants/admin/settings';

class PerformancesModal extends Component {
    state = { copyForByCategory: {}, comment: '' };

    _getCategoryFields = () => {
        const categories = this.props.categories;
        return {
            categoryFields: categories.filter(f => f.labels && f.labels.length > 0)
        };
    };

    _isCategoryVisibleForPartner = (category, partnerId) => {
        if (!category) return false;
        if (category.visibleByDefault) return true;
        const visibleByPartners = category.visibleByPartners || [];
        return visibleByPartners.includes(partnerId);
    };

    _getFieldOptions = category => {
        if (!category.labels || category.labels.length === 0) {
            return [];
        }
        return category.labels.map(label => ({
            value: label.label,
            label: label.label,
            color: label.color || null
        }));
    };

    _getSelectedLabel = category => {
        const categoryValue = this.state[category.id];
        if (!categoryValue || !categoryValue.labelId) return '';

        const label = category.labels?.find(label => label.id === categoryValue.labelId);
        return label?.label || '';
    };

    _getUntilDate = category => {
        const categoryValue = this.state[category.id];
        if (!categoryValue) return UNLIMITED_DATE;
        return categoryValue.untilDate || UNLIMITED_DATE;
    };

    _onCategoryChange = (labelText, categoryId, category) => {
        const label = category.labels?.find(label => label.label === labelText);
        this.setState({
            [categoryId]: {
                labelId: label?.id || '',
                untilDate: this.state[categoryId]?.untilDate || UNLIMITED_DATE
            }
        });
    };

    _onUntilDateChange = (value, categoryId) => {
        this.setState(prevState => ({
            [categoryId]: {
                ...(prevState[categoryId] || {}),
                untilDate: value
            }
        }));
    };

    _onCommentsChange = value => {
        this.setState({ comment: value });
    };

    _onCopyForCategoryChange = (categoryId, value) => {
        this.setState(prevState => ({
            copyForByCategory: {
                ...prevState.copyForByCategory,
                [categoryId]: value || []
            }
        }));
    };

    _initializeState = (partnerData = null) => {
        const categories = this.props.categories;
        const newState = { copyForByCategory: {}, comment: partnerData?.comment || '' };

        categories.forEach(category => {
            const value = partnerData ? get(partnerData, category.id, null) : null;

            if (typeof value === 'object' && value !== null) {
                newState[category.id] = {
                    labelId: value.labelId || '',
                    untilDate: value.untilDate || UNLIMITED_DATE
                };
            } else {
                newState[category.id] = {
                    labelId: '',
                    untilDate: UNLIMITED_DATE
                };
            }

            newState.copyForByCategory[category.id] = [];
        });

        this.setState(newState);
    };

    _closeModal = () => {
        this.props.closeModal();
        this._initializeState();
    };

    _saveModal = () => {
        this.props.saveModal(this.props.open.partnerId, this.state);
        this._initializeState();
    };

    _hasMissingRequiredDates = () => {
        // Future implementation for required date validation
        return false;
    };

    _getDuplicatePartnerOptionsForCategory = category => {
        const { dependencies, open } = this.props;
        if (!dependencies || !dependencies.partners || !open || !category) {
            return [];
        }
        const partnersWithAccess = filter(
            dependencies.partners,
            partner => partner.id !== open.partnerId && this._isCategoryVisibleForPartner(category, partner.id)
        );
        return toSelectionFormat(partnersWithAccess);
    };

    componentDidUpdate(prevProps) {
        if (!prevProps.open && this.props.open) {
            this._initializeState(this.props.open);
        }
    }

    render() {
        const { open, getPartnerName } = this.props;

        if (!open) return null;

        const { categoryFields } = this._getCategoryFields();
        const partnerName = getPartnerName(open) || '';

        return (
            <Modal className="is-big is-black" open={open} onClose={this._closeModal}>
                <h4 className="ckp-admin-modal-forms-title ckp-ts-h1">{`${partnerName} Clearance`}</h4>

                <div className="ckp-modal-grid">
                    {categoryFields.map(category => (
                        <div className="ckp-modal-grid-item ckp-modal-grid-item--with-duplicate" key={category.id}>
                            <div>
                                <SelectField
                                    label={category.label}
                                    onChange={value => this._onCategoryChange(value, category.id, category)}
                                    name={category.id}
                                    items={this._getFieldOptions(category)}
                                    value={this._getSelectedLabel(category)}
                                />
                            </div>
                            <div>
                                <DatepickerUnlimited
                                    onChange={value => this._onUntilDateChange(value, category.id)}
                                    value={this._getUntilDate(category)}
                                    label="Until Date"
                                    name={`${category.id}_untilDate`}
                                />
                            </div>
                            <div className="ckp-modal-grid-item-duplicate">
                                <SelectField
                                    multiple={true}
                                    value={this.state.copyForByCategory[category.id] || []}
                                    name={`copyFor-${category.id}`}
                                    label="Duplicate for"
                                    onChange={value => this._onCopyForCategoryChange(category.id, value)}
                                    items={this._getDuplicatePartnerOptionsForCategory(category)}
                                />
                            </div>
                        </div>
                    ))}
                </div>

                <TextArea value={this.state.comment} onChange={this._onCommentsChange} name="comment" label="Comment" />

                {/* Action Buttons */}
                <ModalButtons
                    confirmLabel="Ok"
                    cancelAction={this._closeModal}
                    confirmAction={this._saveModal}
                    inactive={this._hasMissingRequiredDates()}
                />
            </Modal>
        );
    }
}

export default PerformancesModal;
